import { forwardRef } from 'react';

/**
 * A utility function that creates a typed React `forwardRef` wrapper with improved type inference for both props and ref.
 * Fixes the common issue where `forwardRef` does not properly infer generic types.
 *
 * @template T The type of the ref instance.
 * @template P The type of the component props (defaults to `object`).
 * @param render - A render function that receives props and a ref, and returns a React element or null.
 * @returns A React component with forwarded ref and proper type inference for both props and ref.
 */
export function fixedForwardRef<T, P = object>(
  render: (props: P, ref: React.Ref<T>) => React.ReactElement | null,
): (props: P & React.RefAttributes<T>) => React.ReactElement | null {
  // biome-ignore lint/suspicious/noExplicitAny: <Need to come back and fix this>
  return forwardRef(render as any) as any;
}
